import { Button } from '@/components/ui/button';
import {
  DialogClose,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Check } from 'lucide-react';
import { FunctionComponent } from 'react';

const TRIAL_FEATURES = [
  'Unlimited projects',
  '100 GB storage',
  'All Core plan features',
  'No credit card required',
];

const TrialWelcomeModal: FunctionComponent = () => {
  return (
    <>
      <DialogHeader>
        <DialogTitle>Welcome to your 30-day free trial!</DialogTitle>
        <DialogDescription>
          Your workspace is set up with a <span className='font-semibold text-foreground'>Core</span> plan trial. Explore
          all features freely — no credit card needed.
        </DialogDescription>
      </DialogHeader>
      <div className='space-y-2 py-2'>
        {TRIAL_FEATURES.map((feature) => (
          <div key={feature} className='flex items-center gap-2 text-sm'>
            <Check className='size-4 text-green-500 shrink-0' />
            <span>{feature}</span>
          </div>
        ))}
      </div>
      <DialogFooter>
        <DialogClose asChild>
          <Button>Get Started</Button>
        </DialogClose>
      </DialogFooter>
    </>
  );
};

export default TrialWelcomeModal;
